module.exports=
{
    "Kingdom": {
        "term": "kingdom",
        "type": "text",
        "group": "taxonomy",
        "dataterm": "dwc:kingdom"
    },
    "Phylum": {
        "term": "phylum",
        "type": "text",
        "group": "taxonomy",
        "dataterm": "dwc:phylum"
    },
    "Class": {
        "term": "class",
        "type": "text",
        "group": "taxonomy",
        "dataterm": "dwc:class"
    },
    "Order": {
        "term": "order",
        "type": "text",
        "group": "taxonomy",
        "dataterm": "dwc:order"
    },
    "Family": {
        "term": "family",
        "type": "text",
        "synonyms": true,
        "default": true,
        "group": "taxonomy",
        "dataterm": "dwc:family"
    },
    "Scientific Name": {
        "term": "scientificname",
        "type": "text",
        "synonyms": true,
        "addall": true,
        "default": true,
        "group": "taxonomy",
        "dataterm": "dwc:scientificName"
    },
    "Genus": {
        "term": "genus",
        "type": "text",
        "synonyms": true,
        "default": true,
        "group": "taxonomy",
        "dataterm": "dwc:genus"
    },
    "Specific Epithet": {
        "term": "specificepithet",
        "type": "text",
        "group": "taxonomy",
        "dataterm": "dwc:specificEpithet",
        "addall": true
    },
    "Infraspecific Epithet": {
        "term": "infraspecificepithet",
        "type": "text",
        "group": "taxonomy",
        "dataterm": "dwc:infraspecificEpithet"
    },
    "Higher Taxon": {
        "term": "highertaxon",
        "type": "text",
        "group": "taxonomy",
        "dataterm": "dwc:higherClassification"
    },
    "Common Name":{
        "term": "commonname",
        "type": "text",
        "group": "taxonomy",
        "dataterm": "dwc:vernacularName"
    },
    "Latitude" : {
        "term": "lat",
        "dataterm": "dwc:decimalLatitude",
        "type": "text",
        "group": "locality",
        "hidden": true,
        "results": true  
    },
    "Longitude": {
        "term": "lon",
        "dataterm": "dwc:decimalLongitude",
        "type": "text",
        "group": "locality",
        "hidden": true,
        "results": true
    },
    "Country": {
        "term": "country",
        "type": "text",
        "default": true,
        "group": "locality",
        "dataterm": "dwc:country"
    },
    "State/Province": {
        "term": "stateprovince",
        "type": "text",
        "default": true,
        "group": "locality",
        "dataterm": "dwc:stateProvince"
    },
    "County/Parish": {
        "term": "county",
        "type": "text",
        "group": "locality",
        "dataterm": "dwc:county"
    },
    "Municipality": {
        "term": "municipality",
        "type": "text",
        "group": "locality",
        "dataterm": "dwc:municipality"
    },
    "Water Body": {
        "term": "waterbody",
        "type": "text",
        "group": "locality",
        "dataterm": "dwc:waterBody"
    },
    "Continent": {
        "term": "continent",
        "type": "text",
        "group": "locality",
        "dataterm": "dwc:continent"
    },
    "Date Collected": {
        "term": "datecollected",
        "type": "daterange",
        "group": "collectionevent",
        "dataterm": "dwc:eventDate"
    },
    "Locality": {
        "term": "locality",
        "type": "text",
        "group": "locality",
        "dataterm": "dwc:locality",
        "tokenized": true
    },
    "Verbatim Locality": {
        "term": "verbatimlocality",
        "type": "text",
        "group": "locality",
        "dataterm": "dwc:verbatimLocality",
        "tokenized": true
    },
    "Institution Name": {
        "term": "institutionname",
        "type": "text",
        "group": "specimen",
        "hidden": true
    },
    "Institution Code": {
        "term": "institutioncode",
        "type": "text",
        "group": "specimen",
        "dataterm": "dwc:institutionCode"
    },
    "Collected By": {
        "term": "collector",
        "type": "text",
        "group": "collectionevent",
        "dataterm": "dwc:recordedBy"
    },
    "Field Number": {
        "term": "fieldnumber",
        "type": "text",
        "group": "collectionevent",
        "dataterm": "dwc:fieldNumber"
    },
    "Collector Number": {
        "term": "recordnumber",
        "type": "text",
        "group": "collectionevent",
        "dataterm": "dwc:recordNumber"
    },
    "Taxon Rank": {
        "term": "taxonrank",
        "type": "text",
        "group": "taxonomy",
        "dataterm": "dwc:taxonRank"
    },
    "Catalog Number": {
        "term": "catalognumber",
        "type": "text",
        "group": "specimen",
        "dataterm": "dwc:catalogNumber"
    },
    "Barcode Value": {
        "term": "barcodevalue",
        "type": "text",
        "group": "specimen",
        "dataterm": "idigbio:barcodeValue"
    },
    "Type Status": {
        "term": "typestatus",
        "type": "text",
        "group": "specimen",
        "dataterm": "dwc:typeStatus"
    },
    "Collection Code": {
        "term": "collectioncode",
        "type": "text",
        "group": "specimen",
        "dataterm": "dwc:collectionCode"
    },
    "Collection Name": {
        "term": "collectionname",
        "type": "text",
        "group": "collectionevent",
        "dataterm": "idigbio:collectionName",
        "hidden": true
    },
    "Minimum Elevation": {
        "term": "minelevation",
        "type": "numericrange",
        "group": "locality",
        "dataterm": "dwc:minimumElevationInMeters"
    },
    "Maximum Elevation": {
        "term": "maxelevation", 
        "type": "numericrange",
        "group": "locality",
        "dataterm": "dwc:maximumElevationInMeters" 
    },
    "Minimum Depth": {
        "term": "mindepth",
        "type": "numericrange",
        "group": "locality",
        "dataterm": "dwc:minimumDepthInMeters"
    },
    "Maximum Depth": {
        "term": "maxdepth",
        "type": "numericrange",
        "group": "locality",
        "dataterm": "dwc:maximumDepthInMeters"
    },
    "Occurrence ID":{
        "term": "occurrenceid",
        "type": "text",
        "group":"specimen",
        "dataterm": "dwc:occurrenceID"
    },
    "Recordset": {
        "term": "recordset",
        "type": "text",
        "group": "specimen"
    },
    "RecordID": {
        "term": "recordids",
        "type": "text",
        "group": "specimen"
    },
    "Basis of Record":{
        "term": "basisofrecord",
        "type": "text",
        "dataterm": "dwc:basisOfRecord",
        "group": "specimen"
    },
    "Bed": {
        "term": "bed",
        "type": "text",
        "group": "paleocontext",
        "dataterm": "dwc:bed"
    },
    "Geological Context Group": {
        "term": "group",
        "type": "text",
        "group": "paleocontext",
        "dataterm": "dwc:group"
    },
    "Member": {
        "term": "member",
        "type": "text",
        "group": "paleocontext",
        "dataterm": "dwc:member"
    },
    "Formation": {
        "term": "formation",
        "type": "text",
        "group": "paleocontext",
        "dataterm": "dwc:formation"
    },
    "Earliest Era": {
        "term": "earliesteraorlowesterathem",
        "type": "text",
        "group": "paleocontext",
        "dataterm": "dwc:earliestEraOrLowestErathem"
    },
    "Latest Era": {
        "term": "latesteraorhighesterathem",
        "type": "text",
        "group": "paleocontext",
        "dataterm": "dwc:latestEraOrHighestErathem"
    },
    "Earliest Eon": {
        "term": "earliesteonorlowesteonothem",
        "type": "text",
        "group": "paleocontext",
        "dataterm": "dwc:earliestEonOrLowestEonothem"
    },
    "Latest Eon": {
        "term": "latesteonorhighesteonothem",
        "type": "text",
        "group": "paleocontext",
        "dataterm": "dwc:latestEonOrHighestEonothem"
    },
    "Earliest Period": {
        "term": "earliestperiodorlowestsystem",
        "type": "text",
        "group": "paleocontext",
        "dataterm": "dwc:earliestPeriodOrLowestSystem"
    },
    "Latest Period": {
        "term": "latestperiodorhighestsystem",
        "type": "text",
        "group": "paleocontext",
        "dataterm": "dwc:latestPeriodOrHighestSystem"
    },
    "Earliest Epoch": {
        "term": "earliestepochorlowestseries",
        "type": "text",
        "group": "paleocontext",
        "dataterm": "dwc:earliestEpochOrLowestSeries"
    },
    "Latest Epoch": {
        "term": "latestepochorhighestseries",
        "type": "text",
        "group": "paleocontext",
        "dataterm": "dwc:latestEpochOrHighestSeries"
    },
    "Earliest Age": {
        "term": "earliestageorloweststage",
        "type": "text",
        "group": "paleocontext",
        "dataterm": "dwc:earliestAgeOrLowestStage"
    },
    "Latest Age": {
        "term": "latestageorhigheststage",
        "type": "text",
        "group": "paleocontext",
        "dataterm": "dwc:latestAgeOrHighestStage"
    },
    "Lowest Biostratigraphic Zone":{
        "term": "lowestbiostratigraphiczone",
        "type": "text",
        "group": "paleocontext",
        "dataterm": "dwc:lowestBiostratigraphicZone"
    },
    "Lithostratigraphic Terms": {
        "term": "lithostratigraphicterms",
        "type": "text",
        "group": "paleocontext",
        "dataterm": "dwc:lithostratigraphicTerms"
    },
    "Data Flags": {
        "term": "flags",
        "type": "text",
        "group": "other"
    },
    "Sequences": {
        "term": "associatedsequences",
        "type": "text",
        "group": "specimen",
        "dataterm": "dwc:associatedSequences"
    },
    "Dataset ID": {
        "term": "datasetid",
        "type": "text",
        "group": "specimen",
        "dataterm": "dwc:datasetID"
    }
}